// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2YWcB","table":"table--eCvjb"};